var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-block"},[_c('a',{staticClass:"d-inline-block",class:{'font-weight-medium': _vm.boldText},attrs:{"data-test":"logoutBtn"},on:{"click":_vm.logout}},[_c('v-icon',{attrs:{"size":_vm.iconSize}},[_vm._v(_vm._s(_vm.ICONS.LOGOUT))]),_vm._v(" "+_vm._s(_vm.$t('auth.logout')))],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }